
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matkat",
      function () {
        return require("private-next-pages/matkat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matkat"])
      });
    }
  